<template>
  <v-container>
    <v-btn class="mb-5" color="default" :to="{
      name: 'membership-College',
      query: {
        collegeModuleId,
        collegeDocumentId: id,
      },
    }">
      <v-icon>{{ mdiArrowLeft }}</v-icon>
      {{ $t('common.back') }}
    </v-btn>
    <v-card :loading="isLoading">
      <v-card-title primary-title v-if="collegeDocument">
        {{ collegeDocument.title }}
      </v-card-title>
      <v-card-text v-if="collegeDocument" v-html="collegeDocument.content" />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiArrowLeft } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ViewDocument',
  module: 'CollegeDocument',
  mixins: [loading],
  data() {
    return {
      mdiArrowLeft,
      collegeModuleId: this.$route.query.collegeModuleId,
      id: this.$route.query.id,
    };
  },
  computed: {
    ...mapState('collegeDocuments', ['collegeDocument']),
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_collegeDocument(this.$route.query.id);
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('collegeDocuments', ['LOAD_collegeDocument']),
  },
};
</script>
